import { apiClient } from 'lib/api';
import { useMutation } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import type { MutationConfig } from 'lib/react-query';
import { queryClient } from 'lib/react-query';
import queryKeys from './queryKeys';


export interface CreateCampaignParams {
  ad_account_id: string;
}

export interface CreateCampaignResponse {
  campaign_id: string;
}

const createCampaign = async (
  body: CreateCampaignParams,
): Promise<CreateCampaignResponse> => {
  const res = await apiClient.post<CreateCampaignResponse>(
    queryKeys.createCampaign,
    body,
  );

  if (isAxiosError(res)) {
    const error = new Error('Axios error');
    error.cause = {
      ...res.response?.data,
      status: res.response?.status,
    };
    return Promise.reject(error);
  }
  return res.data;
};

interface UseOptions {
  config?: MutationConfig<typeof createCampaign>;
}

const useCreateCampaign = ({ config }: UseOptions = {}) => {
  return useMutation({
    ...config,
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.campaigns],
      });

      if (config?.onSuccess) {
        config.onSuccess(...args);
      }
    },
    onError: (...args) => {
      if (config?.onError) {
        config.onError(...args);
      }
    },
    mutationFn: createCampaign,
  });
};

export { createCampaign, useCreateCampaign };
